// import React, { useEffect, useState, useRef, memo, useMemo, useCallback } from "react";
// import axios from "axios";
// import { Helmet } from "react-helmet-async";
// import { useNavigate, useParams } from "react-router-dom";
// import { getToken, getUser } from "../utils/auth";
// import Stars from "../components/common/Stars";
// import { useTranslation } from "react-i18next";
// import { useCurrency } from "../context/CurrencyContext";
// import CONFIG from "../config";
// import BRANDING from "../branding";
// import SEO from "../components/common/SEO";

// const ProductDetail = memo(() => {
//   const { t, i18n } = useTranslation();
//   const isArabic = i18n.language?.startsWith('ar');
//   const { formatPrice } = useCurrency();
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [product, setProduct] = useState(null);
//   const [mainImage, setMainImage] = useState(null);
//   const [zoom, setZoom] = useState(false);
//   const [zoomPosition, setZoomPosition] = useState({ x: 0, y: 0 });
//   const [reviews, setReviews] = useState([]);
//   const [reviewsPage, setReviewsPage] = useState(1);
//   const [reviewsPer] = useState(5);
//   const [reviewsTotal, setReviewsTotal] = useState(0);
//   const [rating, setRating] = useState(5);
//   const [comment, setComment] = useState("");
//   const [recommendations, setRecommendations] = useState([]);
//   const [liking, setLiking] = useState(false);
//   const [distribution, setDistribution] = useState({});
//   const [sort, setSort] = useState("newest");
//   const [editing, setEditing] = useState(null);
//   const [editData, setEditData] = useState({ rating: 5, comment: "" });
//   const [honeypot, setHoneypot] = useState("");
//   const [reviewName, setReviewName] = useState("");
//   const [contact, setContact] = useState("");
//   const [now, setNow] = useState(Date.now());

//   useEffect(() => {
//     const timer = setInterval(() => setNow(Date.now()), 1000 * 30); // update every 30s
//     return () => clearInterval(timer);
//   }, []);

//   const viewedIdRef = useRef(null);

//   useEffect(() => {
//     if (!id) return;
//     if (viewedIdRef.current === id) return;
//     viewedIdRef.current = id;

//     const fetchProductData = async () => {
//       try {
//         await axios.post(`${CONFIG.API_URL}/api/products/product/${id}/view`).catch(() => { });
//         const res = await axios.get(`${CONFIG.API_URL}/api/products/${id}`);
//         setProduct(res.data);
//         const initialImg = res.data.imageUrl ||
//           (res.data.thumbnailUrls && res.data.thumbnailUrls[0]) ||
//           res.data.thumbnail1 ||
//           null;
//         setMainImage(initialImg);

//         const recRes = await axios.get(`${CONFIG.API_URL}/api/products/${id}/recommendations`);
//         setRecommendations(recRes.data || []);
//       } catch (err) {
//         console.error("Error loading product data:", err);
//       }
//     };

//     fetchProductData();
//   }, [id]);

//   const fetchReviews = useCallback(async (page = reviewsPage) => {
//     try {
//       const res = await axios.get(`${CONFIG.API_URL}/api/reviews/${id}?page=${page}&per=${reviewsPer}&sort=${sort}`);
//       setReviews(res.data.data || []);
//       setReviewsTotal(res.data.meta?.total || 0);
//       if (res.data.distribution) setDistribution(res.data.distribution);
//     } catch (e) {
//       setReviews([]);
//     }
//   }, [id, reviewsPer, sort, reviewsPage]);

//   useEffect(() => {
//     fetchReviews(reviewsPage);
//   }, [id, reviewsPage, sort, fetchReviews]);

//   const [liked, setLiked] = useState(false);

//   useEffect(() => {
//     const check = async () => {
//       try {
//         const token = getToken();
//         const headers = token ? { Authorization: `Bearer ${token}` } : {};
//         const res = await axios.get(`${CONFIG.API_URL}/api/products/product/${id}/like-status`, { headers });
//         setLiked(!!res.data?.liked);
//       } catch (e) {
//         setLiked(false);
//       }
//     };
//     if (id) check();
//   }, [id]);

//   const handleMouseMove = (e) => {
//     const { left, top, width, height } = e.target.getBoundingClientRect();
//     const x = ((e.pageX - left) / width) * 100;
//     const y = ((e.pageY - top) / height) * 100;
//     setZoomPosition({ x, y });
//   };

//   const submitReview = useCallback(async () => {
//     try {
//       const token = getToken();
//       const user = getUser();
//       const payload = { product_id: id, rating, comment, contact, honeypot };
//       if (reviewName) {
//         payload.name = reviewName;
//       } else if (user) {
//         payload.name = user.username || user.name || user.email;
//       }
//       if (!payload.name) {
//         return alert(t('product_detail.name_req', 'Name (Required)'));
//       }
//       const headers = token ? { Authorization: `Bearer ${token}` } : {};
//       await axios.post(`${CONFIG.API_URL}/api/reviews`, payload, { headers });
//       alert(t('product_detail.alerts.submitted'));
//       setComment("");
//       setHoneypot("");
//       setReviewName("");
//       setContact("");
//       const r = await axios.get(`${CONFIG.API_URL}/api/reviews/${id}?page=1&per=${reviewsPer}`);
//       setReviews(r.data.data || []);
//       setReviewsTotal(r.data.meta?.total || 0);
//     } catch (err) {
//       console.error(err);
//       alert(err.response?.data?.message || t('product_detail.alerts.failed'));
//     }
//   }, [id, rating, comment, contact, honeypot, reviewName, t, reviewsPer]);

//   const voteHelpful = useCallback(async (reviewId) => {
//     try {
//       const token = getToken();
//       const headers = token ? { Authorization: `Bearer ${token}` } : {};
//       await axios.post(`${CONFIG.API_URL}/api/reviews/${reviewId}/vote`, {}, { headers });
//       fetchReviews();
//     } catch (err) {
//       alert(err.response?.data?.message || t('product_detail.alerts.vote_failed'));
//     }
//   }, [fetchReviews, t]);

//   const saveEdit = useCallback(async (reviewId) => {
//     try {
//       const token = getToken();
//       const headers = token ? { Authorization: `Bearer ${token}` } : {};
//       await axios.put(`${CONFIG.API_URL}/api/reviews/${reviewId}`, editData, { headers });
//       alert("Review updated (awaiting re-approval)");
//       setEditing(null);
//       fetchReviews();
//     } catch (err) {
//       alert(err.response?.data?.message || t('product_detail.alerts.update_failed'));
//     }
//   }, [editData, fetchReviews, t]);

//   // useMemo example: memoizing derived data to avoid recalculation on every render (like when 'now' state updates)
//   const uniqueThumbs = useMemo(() => {
//     if (!product) return [];
//     const thumbs = [
//       product.imageUrl,
//       ...(product.thumbnailUrls || []),
//       product.thumbnail1,
//       product.thumbnail2,
//       product.thumbnail3,
//       product.thumbnail4,
//       product.thumbnail5
//     ].filter(Boolean);
//     return [...new Set(thumbs)];
//   }, [product]);

//   const seoTitle = product
//     ? `${isArabic && product.name_ar ? product.name_ar : product.name} | ${isArabic ? BRANDING.appName.ar : BRANDING.appName.en}`
//     : (isArabic ? BRANDING.seo.defaultTitle.ar : BRANDING.seo.defaultTitle.en);

//   const seoDesc = product
//     ? (isArabic && product.description_ar ? product.description_ar : product.description)
//     : (isArabic ? BRANDING.seo.defaultDescription.ar : BRANDING.seo.defaultDescription.en);

//   const seoImage = mainImage ? (mainImage.startsWith('http') ? mainImage : window.location.origin + mainImage) : (window.location.origin + "/logo.png");

//   return (
//     <>
//       <Helmet>
//         <html lang={isArabic ? "ar" : "en"} dir={isArabic ? "rtl" : "ltr"} />
//         <title>{seoTitle}</title>
//         <meta name="description" content={seoDesc} />

//         {/* Open Graph / Facebook / Instagram / TikTok */}
//         <meta property="og:type" content="product" />
//         <meta property="og:url" content={window.location.href} />
//         <meta property="og:title" content={seoTitle} />
//         <meta property="og:description" content={seoDesc} />
//         <meta property="og:image" content={seoImage} />

//         {/* Commerce Specific (TikTok/Facebook/Instagram) */}
//         {product && (
//           <>
//             <meta property="product:price:amount" content={product.price_egp || product.price} />
//             <meta property="product:price:currency" content="EGP" />
//             <meta property="og:price:amount" content={product.price_egp || product.price} />
//             <meta property="og:price:currency" content="EGP" />
//             <meta property="product:brand" content={BRANDING.appName.en} />
//             <meta property="product:availability" content="in stock" />
//             <meta property="product:condition" content="new" />
//             <meta property="product:retailer_item_id" content={product.id} />
//             <meta property="og:site_name" content={isArabic ? BRANDING.appName.ar : BRANDING.appName.en} />
//           </>
//         )}

//         {/* Twitter */}
//         <meta property="twitter:card" content="summary_large_image" />
//         <meta property="twitter:url" content={window.location.href} />
//         <meta property="twitter:title" content={seoTitle} />
//         <meta property="twitter:description" content={seoDesc} />
//         <meta property="twitter:image" content={seoImage} />

//         {product && (
//           <script type="application/ld+json">
//             {JSON.stringify({
//               "@context": "https://schema.org",
//               "@type": "Product",
//               "name": isArabic && product.name_ar ? product.name_ar : product.name,
//               "image": [seoImage],
//               "description": isArabic && product.description_ar ? product.description_ar : product.description,
//               "sku": `PROD-${product.id}`,
//               "brand": {
//                 "@type": "Brand",
//                 "name": isArabic ? BRANDING.appName.ar : BRANDING.appName.en
//               },
//               "aggregateRating": {
//                 "@type": "AggregateRating",
//                 "ratingValue": product.avg_rating || 5,
//                 "reviewCount": product.reviews_count || 1
//               },
//               "offers": {
//                 "@type": "Offer",
//                 "price": product.price_egp || product.price,
//                 "priceCurrency": "EGP",
//                 "availability": "https://schema.org/InStock",
//                 "itemCondition": "https://schema.org/NewCondition",
//                 "url": window.location.href,
//                 "seller": {
//                   "@type": "Organization",
//                   "name": isArabic ? BRANDING.appName.ar : BRANDING.appName.en
//                 }
//               }
//             })}
//           </script>
//         )}
//       </Helmet>
//       <SEO />

//       {!product ? (
//         <div className="min-h-screen flex items-center justify-center font-medium text-gray-400 animate-pulse">
//           {t('home.loading')}
//         </div>
//       ) : (
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
//           {/* Breadcrumb / Back Button */}
//           <button
//             onClick={() => navigate("/shop")}
//             className="group mb-8 flex items-center gap-2 text-sm font-semibold text-gray-500 hover:text-brand-primary transition-colors"
//           >
//             <span className={`transition-transform group-hover:-translate-x-1 ${isArabic ? "rotate-180 group-hover:translate-x-1" : ""}`}>
//               <i className="fas fa-chevron-left"></i>
//             </span>
//             {t('shop.back_to_shop', 'Back to Shop')}
//           </button>

//           <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
//             {/* LEFT: Image Gallery */}
//             <div className="w-full lg:w-3/5">
//               <div className="flex flex-col-reverse md:flex-row gap-4">
//                 {/* Thumbnails (Side on medium screens, Bottom on small) */}
//                 <div className="flex md:flex-col gap-3 overflow-x-auto md:overflow-y-auto max-h-[100px] md:max-h-[600px] no-scrollbar flex-shrink-0">
//                   {uniqueThumbs.map((img, i) => (
//                     <div
//                       key={i}
//                       onClick={() => setMainImage(img)}
//                       className={`
//                         min-w-[80px] md:min-w-0 w-20 h-20 md:w-24 md:h-24 rounded-xl overflow-hidden cursor-pointer border-2 transition-all flex-shrink-0
//                         ${mainImage === img ? "border-brand-primary shadow-md scale-95" : "border-transparent hover:border-brand-primary/30"}
//                       `}
//                       style={{ borderRadius: 'var(--card-radius)' }}
//                     >
//                       <img src={img} alt={`thumbnail-${i}`} className="w-full h-full object-cover" />
//                     </div>
//                   ))}
//                 </div>

//                 {/* Main Image with Professional Zoom */}
//                 <div className="flex-1">
//                   <div
//                     className="relative aspect-[4/5] overflow-hidden cursor-crosshair group"
//                     style={{ backgroundColor: 'var(--bg-body)', borderRadius: 'var(--card-radius)', border: '1px solid var(--border)', boxShadow: 'var(--card-shadow)' }}
//                     onMouseEnter={() => setZoom(true)}
//                     onMouseLeave={() => setZoom(false)}
//                     onMouseMove={handleMouseMove}
//                   >
//                     {mainImage ? (
//                       <>
//                         <img
//                           src={mainImage}
//                           alt={product.name}
//                           className={`w-full h-full object-cover transition-transform duration-300 ease-out ${zoom ? "opacity-0" : "opacity-100"}`}
//                         />
//                         {/* Zoomed version */}
//                         {zoom && (
//                           <div
//                             className="absolute inset-0 bg-no-repeat pointer-events-none"
//                             style={{
//                               backgroundImage: `url(${mainImage})`,
//                               backgroundPosition: `${zoomPosition.x}% ${zoomPosition.y}%`,
//                               backgroundSize: '250%' // Zoom level
//                             }}
//                           />
//                         )}
//                       </>
//                     ) : (
//                       <div className="h-full flex items-center justify-center text-gray-400 italic">
//                         {t('product_detail.no_image')}
//                       </div>
//                     )}

//                     {/* Floating Zoom Icon hint */}
//                     <div
//                       className="absolute top-4 right-4 backdrop-blur-md p-2 rounded-full shadow-sm opacity-0 group-hover:opacity-100 transition-opacity"
//                       style={{ backgroundColor: 'var(--bg-header)', opacity: 0.8 }}
//                     >
//                       <i className="fas fa-search-plus text-gray-600 text-sm"></i>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* RIGHT: Product Info (Sticky on desktop) */}
//             <div className="w-full lg:w-2/5">
//               <div className="lg:sticky lg:top-24 space-y-8">
//                 {/* Header Info */}
//                 <div>
//                   <div className="flex items-center gap-2 text-brand-primary font-bold text-xs uppercase tracking-widest mb-3">
//                     <i className="fas fa-couch"></i>
//                     {(product.categories || []).map(cat => (isArabic && cat.name_ar ? cat.name_ar : cat.name)).join(", ")}
//                   </div>
//                   <h1 className="text-3xl sm:text-4xl font-extrabold leading-tight mb-4" style={{ color: 'var(--text-header)' }}>
//                     {isArabic && product.name_ar ? product.name_ar : product.name}
//                   </h1>
//                   <div className="flex items-center gap-4">
//                     <div className="flex items-center gap-2 bg-yellow-50 px-3 py-1.5 rounded-full">
//                       <Stars value={product.avg_rating || 0} />
//                       <span className="text-xs font-bold text-yellow-700">({product.reviews_count || 0})</span>
//                     </div>
//                     <span className="text-sm text-gray-500 font-medium">| {product.views || 0} {t('admin.analytics_page.total_views', 'Views')}</span>
//                   </div>
//                 </div>

//                 {/* Price */}
//                 <div
//                   className="relative p-6 border overflow-hidden"
//                   style={{ borderRadius: 'var(--card-radius)', borderColor: 'var(--primary)' }}
//                 >
//                   <div className="absolute inset-0 pointer-events-none" style={{ backgroundColor: 'var(--primary)', opacity: 0.05 }}></div>
//                   <div className="relative flex items-end gap-3 text-brand-primary z-10">
//                     <span className="text-4xl font-black">{formatPrice(product)}</span>
//                   </div>
//                   <p className="relative text-xs text-gray-500 mt-2 italic z-10">* {t('home.hero_subtitle', 'High-quality made to last.')}</p>
//                 </div>

//                 {/* Description */}
//                 <div>
//                   <h3 className="text-lg font-bold mb-3" style={{ color: 'var(--text-header)' }}>{t('contact.message', 'Description')}</h3>
//                   <p className="text-gray-600 leading-relaxed text-base">
//                     {isArabic && product.description_ar ? product.description_ar : product.description}
//                   </p>
//                 </div>

//                 {/* Attributes Grid */}
//                 <div className="grid grid-cols-2 gap-4">
//                   {[
//                     { label: t('product_detail.color'), value: isArabic ? (product.color_ar || t(`colors.${product.color}`, product.color)) : product.color, icon: 'fa-palette' },
//                     { label: t('product_detail.material'), value: isArabic && product.material_ar ? product.material_ar : product.material, icon: 'fa-layer-group' },
//                     { label: t('product_detail.dimensions'), value: isArabic && product.dimensions_ar ? product.dimensions_ar : product.dimensions, icon: 'fa-ruler-combined', full: true },
//                   ].map((attr, idx) => attr.value && (
//                     <div
//                       key={idx}
//                       className={`p-4 border ${attr.full ? 'col-span-2' : ''}`}
//                       style={{ backgroundColor: 'var(--bg-body)', borderRadius: 'var(--input-radius)', borderColor: 'var(--border)' }}
//                     >
//                       <div className="flex items-center gap-2 text-gray-400 text-[10px] uppercase font-bold tracking-wider mb-1">
//                         <i className={`fas ${attr.icon}`}></i>
//                         {attr.label}
//                       </div>
//                       <div className="font-bold text-sm" style={{ color: 'var(--text-main)' }}>{attr.value}</div>
//                     </div>
//                   ))}
//                 </div>

//                 {/* Actions: Video & Shared Actions Row */}
//                 <div className="space-y-4 pt-4 border-t" style={{ borderColor: 'var(--border)' }}>
//                   {product.videoUrl && (
//                     <div
//                       className="overflow-hidden border"
//                       style={{ borderRadius: 'var(--card-radius)', borderColor: 'var(--border)', backgroundColor: 'var(--bg-body)' }}
//                     >
//                       <div className="p-3 text-xs font-bold text-brand-primary flex items-center gap-2 border-b" style={{ borderColor: 'var(--border)' }}>
//                         <i className="fas fa-play-circle"></i> {t('shop.has_video', 'Product Video')}
//                       </div>
//                       <video src={product.videoUrl} controls className="w-full" />
//                     </div>
//                   )}

//                   <div className="flex items-center gap-4 flex-wrap">
//                     <button
//                       disabled={liking}
//                       className={`
//                         flex-1 px-6 py-4 flex items-center justify-center gap-2 rounded-2xl transition-all font-bold shadow-md
//                         ${liked ? "bg-red-50 text-red-600 border-2 border-red-100" : "border-2 hover:border-brand-primary/20"}
//                       `}
//                       style={{
//                         backgroundColor: liked ? '#fef2f2' : 'var(--bg-header)',
//                         borderColor: liked ? '#fee2e2' : 'var(--border)',
//                         color: liked ? '#dc2626' : 'var(--text-header)',
//                         borderRadius: 'var(--button-radius)'
//                       }}
//                       onClick={async () => {
//                         try {
//                           setLiking(true);
//                           const token = getToken();
//                           const headers = token ? { Authorization: `Bearer ${token}` } : {};
//                           const r = await axios.post(`${CONFIG.API_URL}/api/products/product/${product.id}/like`, {}, { headers });
//                           setProduct(prev => ({ ...prev, likes: r.data.likes }));
//                           setLiked(!!r.data.liked);
//                         } catch (err) { } finally { setLiking(false); }
//                       }}
//                     >
//                       <i className={`${liked ? "fas" : "far"} fa-heart text-xl`}></i>
//                       <span>{product.likes} {t('product_detail.likes', 'Likes')}</span>
//                     </button>

//                     <div className="flex gap-3">
//                       {/* WhatsApp Share */}
//                       <a
//                         href={`https://wa.me/${BRANDING.socialLinks.whatsapp.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(`${isArabic && product.name_ar ? product.name_ar : product.name}\n${window.location.href}`)}`}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         onClick={() => {
//                           if (window.fbq) window.fbq('track', 'Contact', { content_name: 'Product WhatsApp Share' });
//                           if (window.ttq) window.ttq.track('Contact');
//                         }}
//                         className="w-14 h-14 rounded-2xl bg-green-500 text-white flex items-center justify-center hover:scale-105 active:scale-95 transition-all shadow-lg shadow-gray-200"
//                       >
//                         <i className="fab fa-whatsapp text-xl"></i>
//                       </a>

//                       {/* Facebook Share */}
//                       <a
//                         href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         onClick={() => {
//                           if (window.fbq) window.fbq('track', 'Share', { content_name: 'Product Facebook Share' });
//                           if (window.ttq) window.ttq.track('Share');
//                         }}
//                         className="w-14 h-14 rounded-2xl bg-blue-600 text-white flex items-center justify-center hover:scale-105 active:scale-95 transition-all shadow-lg shadow-gray-200"
//                       >
//                         <i className="fab fa-facebook-f text-xl"></i>
//                       </a>
//                       <button
//                         onClick={() => { navigator.clipboard.writeText(window.location.href); alert(t('product_detail.link_copied', 'Link copied!')); }}
//                         className="w-14 h-14 rounded-2xl bg-gray-800 text-white flex items-center justify-center hover:scale-105 active:scale-95 transition-all shadow-lg shadow-gray-200"
//                         title="Copy Link"
//                       >
//                         <i className="fas fa-link text-lg"></i>
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="mt-16 border-t pt-10">
//             <h3 className="text-2xl font-bold mb-4">{t('product_detail.customer_reviews')}</h3>
//             {[5, 4, 3, 2, 1].map(star => {
//               const count = distribution[star] || 0;
//               const percent = reviewsTotal > 0 ? (count / reviewsTotal) * 100 : 0;
//               return (
//                 <div key={star} className="flex items-center gap-2 text-sm mb-1">
//                   <span className="w-6">{star}★</span>
//                   <div className="flex-1 bg-gray-200 h-2 rounded overflow-hidden">
//                     <div className="bg-yellow-400 h-2 rounded" style={{ width: `${percent}%` }} />
//                   </div>
//                   <span className="text-xs text-gray-500 w-6 text-right">{count}</span>
//                 </div>
//               );
//             })}

//             <div className="mt-6 flex justify-between items-center">
//               <select value={sort} onChange={e => setSort(e.target.value)} className="border p-2 rounded">
//                 <option value="newest">{t('product_detail.newest')}</option>
//                 <option value="helpful">{t('product_detail.helpful')}</option>
//                 <option value="rating">{t('product_detail.highest_rating')}</option>
//               </select>
//             </div>

//             <div className="mt-6 space-y-6">
//               {reviews.length === 0 && <p className="text-gray-500 italic">{t('product_detail.no_reviews')}</p>}
//               {reviews.map(r => {
//                 const createdAt = new Date(r.created_at).getTime();
//                 const diffMins = Math.floor((now - createdAt) / (1000 * 60));
//                 // This code, requires you to be logged in to edit anything
//                 // const canEdit = r.user_id == getUser()?.id && diffMins < 15;
//                 // This code without login, the Guests effectively cannot edit their reviews after posting
//                 const currentUser = getUser();
//                 const canEdit = currentUser && r.user_id === currentUser.id && diffMins < 15;
//                 ////////////////////
//                 const minsLeft = 15 - diffMins;
//                 return (
//                   <div key={r.id} className="border-b pb-6">
//                     <div className="flex justify-between items-start mb-2">
//                       <div>
//                         <span className="font-bold" style={{ color: 'var(--text-header)' }}>
//                           {isArabic ? ` ${r.name} ` : r.name}
//                         </span>
//                         {r.is_verified && <span className="ml-2 text-green-600 text-xs font-semibold uppercase">{isArabic ? ` ${t('product_detail.verified')}` : `${t('product_detail.verified')}`}</span>}
//                         <span className="ml-3 text-yellow-500">{isArabic ? ` ${"★".repeat(r.rating)}` : "★".repeat(r.rating)}</span>
//                       </div>
//                       {canEdit && editing !== r.id && (
//                         <button onClick={() => { setEditing(r.id); setEditData({ rating: r.rating, comment: r.comment }); }} className="text-xs text-brand-primary underline">
//                           Edit ({minsLeft}m left)
//                         </button>
//                       )}
//                     </div>
//                     {editing === r.id ? (
//                       <div className="mt-4 space-y-2 p-4" style={{ backgroundColor: 'var(--bg-body)', borderRadius: 'var(--card-radius)' }}>
//                         <select value={editData.rating} onChange={e => setEditData({ ...editData, rating: e.target.value })} className="border p-1 rounded">
//                           {[5, 4, 3, 2, 1].map(n => <option key={n} value={n}>{n} {t('product_detail.stars')}</option>)}
//                         </select>
//                         <textarea className="w-full border rounded p-2 text-sm" value={editData.comment} onChange={e => setEditData({ ...editData, comment: e.target.value })} />
//                         <div className="flex gap-2">
//                           <button onClick={() => saveEdit(r.id)} className="bg-brand-primary text-white px-3 py-1 rounded text-xs">Save</button>
//                           <button onClick={() => setEditing(null)} className="text-gray-400 text-xs">Cancel</button>
//                         </div>
//                       </div>
//                     ) : <p className="mt-2" style={{ color: 'var(--text-main)' }}>{r.comment}</p>}
//                     <div className="flex items-center gap-4 mt-3 text-xs text-gray-500">
//                       <button onClick={() => voteHelpful(r.id)} className="flex items-center gap-1 hover:text-brand-primary transition">
//                         👍 {t('product_detail.helpful_btn')} ({r.helpful_count})
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>

//             {reviewsTotal > reviewsPer && (
//               <div className="flex items-center gap-3 mt-8 justify-center">
//                 <button onClick={() => setReviewsPage(p => Math.max(1, p - 1))} className="px-3 py-1 bg-gray-100 rounded disabled:opacity-50" disabled={reviewsPage <= 1}>{t('product_detail.prev')}</button>
//                 <span className="text-sm">{t('product_detail.page')} {reviewsPage} / {Math.ceil(reviewsTotal / reviewsPer)}</span>
//                 <button onClick={() => setReviewsPage(p => p + 1)} className="px-3 py-1 bg-gray-100 rounded disabled:opacity-50" disabled={reviewsPage >= Math.ceil(reviewsTotal / reviewsPer)}>{t('product_detail.next')}</button>
//               </div>
//             )}

//             <div className="mt-12 p-6 border border-dashed" style={{ backgroundColor: 'var(--bg-body)', borderRadius: 'var(--card-radius)', borderColor: 'var(--border)' }}>
//               <h4 className="text-xl font-bold mb-4">{t('product_detail.write_review')}</h4>
//               <div className="flex items-center gap-4 mb-4">
//                 <span className="text-sm font-medium">{t('product_detail.your_rating')}:</span>
//                 <select value={rating} onChange={e => setRating(e.target.value)} className="border p-1 rounded focus:ring-2 focus:ring-blue-400 outline-none">
//                   {[5, 4, 3, 2, 1].map(n => <option key={n} value={n}>{n} {t('product_detail.stars')}</option>)}
//                 </select>
//               </div>
//               <div style={{ display: 'none' }}>
//                 <input type="text" value={honeypot} onChange={e => setHoneypot(e.target.value)} tabIndex="-1" autoComplete="off" />
//               </div>
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//                 <input type="text" className="w-full border rounded-lg p-2 text-sm focus:ring-2 focus:ring-blue-400 outline-none" placeholder={t('product_detail.name_req', 'Name (Required)')} value={reviewName} onChange={e => setReviewName(e.target.value)} required aria-required="true" />
//                 <input type="text" className="w-full border rounded-lg p-2 text-sm focus:ring-2 focus:ring-blue-400 outline-none" placeholder={t('product_detail.contact_opt', 'Phone/Email (Optional, private)')} value={contact} onChange={e => setContact(e.target.value)} />
//               </div>
//               <textarea className="w-full border rounded-lg p-3 text-sm focus:ring-2 focus:ring-blue-400 outline-none mb-4 h-32" placeholder={t('product_detail.placeholder')} value={comment} onChange={e => setComment(e.target.value)} />
//               <button onClick={submitReview} className="bg-brand-primary hover:bg-brand-primary-hover text-white px-6 py-2 rounded-lg font-semibold transition shadow-md">{t('product_detail.post')}</button>
//             </div>
//           </div>

//           {recommendations.length > 0 && (
//             <div className="mt-20 border-t pt-10">
//               <h2 className="text-2xl font-bold mb-6 text-center">{t('product_detail.also_like')}</h2>
//               <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
//                 {recommendations.map((p) => (
//                   <div key={p.id} className="group cursor-pointer" onClick={() => navigate(`/shop/${p.id}`)}>
//                     <div className="aspect-square bg-gray-100 rounded-lg overflow-hidden mb-3 relative">
//                       <img src={p.imageUrl || "/placeholder-furniture.jpg"} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition duration-300" />
//                     </div>
//                     <h3 className="font-semibold text-sm truncate">{i18n.language?.startsWith('ar') && p.name_ar ? p.name_ar : p.name}</h3>
//                     <div className="flex items-center mt-1">
//                       <Stars value={p.avg_rating || 0} />
//                       <span className="text-[10px] text-gray-400 ml-1">({p.reviews_count || 0})</span>
//                     </div>
//                     <p className="text-brand-primary font-bold text-sm mt-1">{formatPrice(p)}</p>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}
//         </div>
//       )}
//     </>
//   );
// });

// export default ProductDetail;







import React, { useEffect, useState, useRef, memo, useMemo, useCallback } from "react";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { useNavigate, useParams } from "react-router-dom";
import { getToken, getUser } from "../utils/auth";
import Stars from "../components/common/Stars";
import { useTranslation } from "react-i18next";
import { useCurrency } from "../context/CurrencyContext";
import CONFIG from "../config";
import BRANDING from "../branding";
import SEO from "../components/common/SEO";
import { useBranding } from "../context/BrandingContext";

const ProductDetail = memo(() => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language?.startsWith('ar');
  const { formatPrice } = useCurrency();
  const { id } = useParams();
  const navigate = useNavigate();
  const { branding } = useBranding();
  const [product, setProduct] = useState(null);
  const [mainImage, setMainImage] = useState(null);
  const [zoom, setZoom] = useState(false);
  const [zoomPosition, setZoomPosition] = useState({ x: 0, y: 0 });

  const [stories, setStories] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const intervalRef = useRef(null); // ✅ To store the polling interval ID

  const [reviews, setReviews] = useState([]);
  const [reviewsPage, setReviewsPage] = useState(1);
  const [reviewsPer] = useState(5);
  const [reviewsTotal, setReviewsTotal] = useState(0);
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState("");
  const [recommendations, setRecommendations] = useState([]);
  const [liking, setLiking] = useState(false);
  const [distribution, setDistribution] = useState({});
  const [sort, setSort] = useState("newest");
  const [editing, setEditing] = useState(null);
  const [editData, setEditData] = useState({ rating: 5, comment: "" });
  const [honeypot, setHoneypot] = useState("");
  const [reviewName, setReviewName] = useState("");
  const [contact, setContact] = useState("");
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 1000 * 30); // update every 30s
    return () => clearInterval(timer);
  }, []);

  const viewedIdRef = useRef(null);

  useEffect(() => {
    if (!id) return;
    if (viewedIdRef.current === id) return;
    viewedIdRef.current = id;

    const fetchProductData = async () => {
      try {
        await axios.post(`${CONFIG.API_URL}/api/products/product/${id}/view`).catch(() => { });
        const res = await axios.get(`${CONFIG.API_URL}/api/products/${id}`);
        setProduct(res.data);
        const initialImg = res.data.imageUrl ||
          (res.data.thumbnailUrls && res.data.thumbnailUrls[0]) ||
          res.data.thumbnail1 ||
          null;
        setMainImage(initialImg);

        const recRes = await axios.get(`${CONFIG.API_URL}/api/products/${id}/recommendations`);
        setRecommendations(recRes.data || []);
      } catch (err) {
        console.error("Error loading product data:", err);
      }
    };

    fetchProductData();
  }, [id]);

  // ✅ Fetch stories from the backend
  const fetchStories = async (showLog = false) => {
    try {
      const token = getToken();
      if (!token) {
        setMessage("❌ You must be logged in to view your stories.");
        setLoading(false);
        return;
      }

      const res = await axios.get(`${CONFIG.API_URL}/api/stories`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const newStories = res.data;
      setStories(newStories);
      setLoading(false);

      // ✅ Check if all stories have videoUrl (video ready)
      const allVideosReady = newStories.every((story) => story.videoUrl);

      if (allVideosReady && intervalRef.current) {
        console.log("✅ All videos ready. Stopping refresh.");
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      } else if (showLog) {
        console.log("🔄 Checking for new videos...");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setMessage("❌ Failed to fetch stories.");
      setLoading(false);
    }
  };

  // ✅ Start polling on component mount
  useEffect(() => {
    fetchStories(); // Initial fetch

    // Set up polling every 10 seconds
    intervalRef.current = setInterval(() => {
      fetchStories(true);
    }, 10000);

    // Cleanup on unmount
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  const fetchReviews = useCallback(async (page = reviewsPage) => {
    try {
      const res = await axios.get(`${CONFIG.API_URL}/api/reviews/${id}?page=${page}&per=${reviewsPer}&sort=${sort}`);
      setReviews(res.data.data || []);
      setReviewsTotal(res.data.meta?.total || 0);
      if (res.data.distribution) setDistribution(res.data.distribution);
    } catch (e) {
      setReviews([]);
    }
  }, [id, reviewsPer, sort, reviewsPage]);

  useEffect(() => {
    fetchReviews(reviewsPage);
  }, [id, reviewsPage, sort, fetchReviews]);

  const [liked, setLiked] = useState(false);

  useEffect(() => {
    const check = async () => {
      try {
        const token = getToken();
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        const res = await axios.get(`${CONFIG.API_URL}/api/products/product/${id}/like-status`, { headers });
        setLiked(!!res.data?.liked);
      } catch (e) {
        setLiked(false);
      }
    };
    if (id) check();
  }, [id]);

  const handleMouseMove = (e) => {
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = ((e.pageX - left) / width) * 100;
    const y = ((e.pageY - top) / height) * 100;
    setZoomPosition({ x, y });
  };

  const submitReview = useCallback(async () => {
    try {
      const token = getToken();
      const user = getUser();
      const payload = { product_id: id, rating, comment, contact, honeypot };
      if (reviewName) {
        payload.name = reviewName;
      } else if (user) {
        payload.name = user.username || user.name || user.email;
      }
      if (!payload.name) {
        return alert(t('product_detail.name_req', 'Name (Required)'));
      }
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      await axios.post(`${CONFIG.API_URL}/api/reviews`, payload, { headers });
      alert(t('product_detail.alerts.submitted'));
      setComment("");
      setHoneypot("");
      setReviewName("");
      setContact("");
      const r = await axios.get(`${CONFIG.API_URL}/api/reviews/${id}?page=1&per=${reviewsPer}`);
      setReviews(r.data.data || []);
      setReviewsTotal(r.data.meta?.total || 0);
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || t('product_detail.alerts.failed'));
    }
  }, [id, rating, comment, contact, honeypot, reviewName, t, reviewsPer]);

  const voteHelpful = useCallback(async (reviewId) => {
    try {
      const token = getToken();
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      await axios.post(`${CONFIG.API_URL}/api/reviews/${reviewId}/vote`, {}, { headers });
      fetchReviews();
    } catch (err) {
      alert(err.response?.data?.message || t('product_detail.alerts.vote_failed'));
    }
  }, [fetchReviews, t]);

  const saveEdit = useCallback(async (reviewId) => {
    try {
      const token = getToken();
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      await axios.put(`${CONFIG.API_URL}/api/reviews/${reviewId}`, editData, { headers });
      alert("Review updated (awaiting re-approval)");
      setEditing(null);
      fetchReviews();
    } catch (err) {
      alert(err.response?.data?.message || t('product_detail.alerts.update_failed'));
    }
  }, [editData, fetchReviews, t]);

  // useMemo example: memoizing derived data to avoid recalculation on every render (like when 'now' state updates)
  const uniqueThumbs = useMemo(() => {
    if (!product) return [];
    const thumbs = [
      product.imageUrl,
      ...(product.thumbnailUrls || []),
      product.thumbnail1,
      product.thumbnail2,
      product.thumbnail3,
      product.thumbnail4,
      product.thumbnail5
    ].filter(Boolean);
    return [...new Set(thumbs)];
  }, [product]);

  const seoTitle = product
    ? `${isArabic && product.name_ar ? product.name_ar : product.name} | ${isArabic ? BRANDING.appName.ar : BRANDING.appName.en}`
    : (isArabic ? BRANDING.seo.defaultTitle.ar : BRANDING.seo.defaultTitle.en);

  const seoDesc = product
    ? (isArabic && product.description_ar ? product.description_ar : product.description)
    : (isArabic ? BRANDING.seo.defaultDescription.ar : BRANDING.seo.defaultDescription.en);

  const seoImage = mainImage ? (mainImage.startsWith('http') ? mainImage : window.location.origin + mainImage) : (window.location.origin + "/logo.png");

  return (
    <>
      <Helmet>
        <html lang={isArabic ? "ar" : "en"} dir={isArabic ? "rtl" : "ltr"} />
        <title>{seoTitle}</title>
        <meta name="description" content={seoDesc} />

        {/* Open Graph / Facebook / Instagram / TikTok */}
        <meta property="og:type" content="product" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDesc} />
        <meta property="og:image" content={seoImage} />

        {/* Commerce Specific (TikTok/Facebook/Instagram) */}
        {product && (
          <>
            <meta property="product:price:amount" content={product.price_egp || product.price} />
            <meta property="product:price:currency" content="EGP" />
            <meta property="og:price:amount" content={product.price_egp || product.price} />
            <meta property="og:price:currency" content="EGP" />
            <meta property="product:brand" content={BRANDING.appName.en} />
            <meta property="product:availability" content="in stock" />
            <meta property="product:condition" content="new" />
            <meta property="product:retailer_item_id" content={product.id} />
            <meta property="og:site_name" content={isArabic ? BRANDING.appName.ar : BRANDING.appName.en} />
          </>
        )}

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={window.location.href} />
        <meta property="twitter:title" content={seoTitle} />
        <meta property="twitter:description" content={seoDesc} />
        <meta property="twitter:image" content={seoImage} />

        {product && (
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Product",
              "name": isArabic && product.name_ar ? product.name_ar : product.name,
              "image": [seoImage],
              "description": isArabic && product.description_ar ? product.description_ar : product.description,
              "sku": `PROD-${product.id}`,
              "brand": {
                "@type": "Brand",
                "name": isArabic ? BRANDING.appName.ar : BRANDING.appName.en
              },
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": product.avg_rating || 5,
                "reviewCount": product.reviews_count || 1
              },
              "offers": {
                "@type": "Offer",
                "price": product.price_egp || product.price,
                "priceCurrency": "EGP",
                "availability": "https://schema.org/InStock",
                "itemCondition": "https://schema.org/NewCondition",
                "url": window.location.href,
                "seller": {
                  "@type": "Organization",
                  "name": isArabic ? BRANDING.appName.ar : BRANDING.appName.en
                }
              }
            })}
          </script>
        )}
      </Helmet>
      <SEO />

      {!product ? (
        <div className="min-h-screen flex items-center justify-center font-medium text-gray-400 animate-pulse">
          {t('home.loading')}
        </div>
      ) : (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
          {/* Breadcrumb / Back Button */}
          <button
            onClick={() => navigate("/shop")}
            className="group mb-8 flex items-center gap-2 text-sm font-semibold text-gray-500 hover:text-brand-primary transition-colors"
          >
            <span className={`transition-transform group-hover:-translate-x-1 ${isArabic ? "rotate-180 group-hover:translate-x-1" : ""}`}>
              <i className="fas fa-chevron-left"></i>
            </span>
            {t('shop.back_to_shop', 'Back to Shop')}
          </button>

          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
            {/* LEFT: Image Gallery */}
            <div className="w-full lg:w-3/5">
              <div className="flex flex-col-reverse md:flex-row gap-4">
                {/* Thumbnails (Side on medium screens, Bottom on small) */}
                <div className="flex md:flex-col gap-3 overflow-x-auto md:overflow-y-auto max-h-[100px] md:max-h-[600px] no-scrollbar flex-shrink-0">
                  {uniqueThumbs.map((img, i) => (
                    <div
                      key={i}
                      onClick={() => setMainImage(img)}
                      className={`
                        min-w-[80px] md:min-w-0 w-20 h-20 md:w-24 md:h-24 rounded-xl overflow-hidden cursor-pointer border-2 transition-all flex-shrink-0
                        ${mainImage === img ? "border-brand-primary shadow-md scale-95" : "border-transparent hover:border-brand-primary/30"}
                      `}
                      style={{ borderRadius: 'var(--card-radius)' }}
                    >
                      <img src={img} alt={`thumbnail-${i}`} className="w-full h-full object-cover" />
                    </div>
                  ))}
                </div>

                {/* Main Image with Professional Zoom */}
                <div className="flex-1">
                  <div
                    className="relative aspect-[4/5] overflow-hidden cursor-crosshair group"
                    style={{ backgroundColor: 'var(--bg-body)', borderRadius: 'var(--card-radius)', border: '1px solid var(--border)', boxShadow: 'var(--card-shadow)' }}
                    onMouseEnter={() => setZoom(true)}
                    onMouseLeave={() => setZoom(false)}
                    onMouseMove={handleMouseMove}
                  >
                    {mainImage ? (
                      <>
                        <img
                          src={mainImage}
                          alt={product.name}
                          className={`w-full h-full object-cover transition-transform duration-300 ease-out ${zoom ? "opacity-0" : "opacity-100"}`}
                        />
                        {/* Zoomed version */}
                        {zoom && (
                          <div
                            className="absolute inset-0 bg-no-repeat pointer-events-none"
                            style={{
                              backgroundImage: `url(${mainImage})`,
                              backgroundPosition: `${zoomPosition.x}% ${zoomPosition.y}%`,
                              backgroundSize: '250%' // Zoom level
                            }}
                          />
                        )}
                      </>
                    ) : (
                      <div className="h-full flex items-center justify-center text-gray-400 italic">
                        {t('product_detail.no_image')}
                      </div>
                    )}

                    {/* Floating Zoom Icon hint */}
                    <div
                      className="absolute top-4 right-4 backdrop-blur-md p-2 rounded-full shadow-sm opacity-0 group-hover:opacity-100 transition-opacity"
                      style={{ backgroundColor: 'var(--bg-header)', opacity: 0.8 }}
                    >
                      <i className="fas fa-search-plus text-gray-600 text-sm"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT: Product Info (Sticky on desktop) */}
            <div className="w-full lg:w-2/5">
              <div className="lg:sticky lg:top-24 space-y-8">
                {/* Header Info */}
                <div>
                  <div className="flex items-center gap-2 text-brand-primary font-bold text-xs uppercase tracking-widest mb-3">
                    {branding?.filterPlaceholders?.category?.icon ? (<i className={`${isArabic ? (`fas ${branding?.filterPlaceholders?.category?.icon}`) : (`fas ${branding?.filterPlaceholders?.category?.icon}`)}`}></i>) : (<i className="fas fa-couch"></i>)}
                    {(product.categories || []).map(cat => (isArabic && cat.name_ar ? cat.name_ar : cat.name)).join(", ")}
                  </div>
                  <h1 className="text-3xl sm:text-4xl font-extrabold leading-tight mb-4" style={{ color: 'var(--text-header)' }}>
                    {isArabic && product.name_ar ? product.name_ar : product.name}
                  </h1>
                  <div className="flex items-center gap-4">
                    <div className="flex items-center gap-2 bg-yellow-50 px-3 py-1.5 rounded-full">
                      <Stars value={product.avg_rating || 0} />
                      <span className="text-xs font-bold text-yellow-700">({product.reviews_count || 0})</span>
                    </div>
                    <span className="text-sm text-gray-500 font-medium">| {product.views || 0} {t('admin.analytics_page.total_views', 'Views')}</span>
                  </div>
                </div>

                {/* Price */}
                <div
                  className="relative p-6 border overflow-hidden"
                  style={{ borderRadius: 'var(--card-radius)', borderColor: 'var(--primary)' }}
                >
                  <div className="absolute inset-0 pointer-events-none" style={{ backgroundColor: 'var(--primary)', opacity: 0.05 }}></div>
                  <div className="relative flex items-end gap-3 text-brand-primary z-10">
                    <span className="text-4xl font-black">{formatPrice(product)}</span>
                  </div>
                  <p className="relative text-xs text-gray-500 mt-2 italic z-10">* {t('home.hero_subtitle', 'High-quality made to last.')}</p>
                </div>

                {/* Description */}
                <div>
                  <h3 className="text-lg font-bold mb-3" style={{ color: 'var(--text-header)' }}>{t('contact.message', 'Description')}</h3>
                  <p className="text-gray-600 leading-relaxed text-base">
                    {isArabic && product.description_ar ? product.description_ar : product.description}
                  </p>
                </div>



                {/* Attributes Grid */}
                <div className="grid grid-cols-2 gap-4">
                  {[
                    { label: t('product_detail.color'), value: isArabic ? (product.color_ar || t(`colors.${product.color}`, product.color)) : product.color, icon: 'fa-palette' },
                    // { label: branding?.filterPlaceholders?.category?.label?.[isArabic ? 'ar' : 'en'] || t('product_detail.color'), value: isArabic ? (product.color_ar || t(`colors.${product.color}`, product.color)) : product.color, icon: branding?.filterPlaceholders?.category?.icon || 'fa-palette' },
                    { label: branding?.filterPlaceholders?.material?.label?.[isArabic ? 'ar' : 'en'] || t('product_detail.material'), value: isArabic && product.material_ar ? product.material_ar : product.material, icon: branding?.filterPlaceholders?.material?.icon || 'fa-layer-group' },
                    { label: branding?.filterPlaceholders?.dimensions?.label?.[isArabic ? 'ar' : 'en'] || t('product_detail.dimensions'), value: isArabic && product.dimensions_ar ? product.dimensions_ar : product.dimensions, icon: branding?.filterPlaceholders?.dimensions?.icon || 'fa-ruler-combined', full: true },
                  ].map((attr, idx) => attr.value && (
                    <div
                      key={idx}
                      className={`p-4 border ${attr.full ? 'col-span-2' : ''}`}
                      style={{ backgroundColor: 'var(--bg-body)', borderRadius: 'var(--input-radius)', borderColor: 'var(--border)' }}
                    >
                      <div className="flex items-center gap-2 text-gray-400 text-[10px] uppercase font-bold tracking-wider mb-1">
                        <i className={`fas ${attr.icon}`}></i>
                        {attr.label}
                      </div>
                      <div className="font-bold text-sm" style={{ color: 'var(--text-main)' }}>{attr.value}</div>
                    </div>
                  ))}
                </div>

                {/* Actions: Video & Shared Actions Row */}
                <div className="space-y-4 pt-4 border-t" style={{ borderColor: 'var(--border)' }}>
                  {product.videoUrl && (
                    <div
                      className="overflow-hidden border"
                      style={{ borderRadius: 'var(--card-radius)', borderColor: 'var(--border)', backgroundColor: 'var(--bg-body)' }}
                    >
                      <div className="p-3 text-xs font-bold text-brand-primary flex items-center gap-2 border-b" style={{ borderColor: 'var(--border)' }}>
                        <i className="fas fa-play-circle"></i> {t('shop.has_video', 'Product Video')}
                      </div>
                      <video src={product.videoUrl} controls className="w-full" />
                    </div>
                  )}

                  <div className="flex items-center gap-4 flex-wrap">
                    <button
                      disabled={liking}
                      className={`
                        flex-1 px-6 py-4 flex items-center justify-center gap-2 rounded-2xl transition-all font-bold shadow-md
                        ${liked ? "bg-red-50 text-red-600 border-2 border-red-100" : "border-2 hover:border-brand-primary/20"}
                      `}
                      style={{
                        backgroundColor: liked ? '#fef2f2' : 'var(--bg-header)',
                        borderColor: liked ? '#fee2e2' : 'var(--border)',
                        color: liked ? '#dc2626' : 'var(--text-header)',
                        borderRadius: 'var(--button-radius)'
                      }}
                      onClick={async () => {
                        try {
                          setLiking(true);
                          const token = getToken();
                          const headers = token ? { Authorization: `Bearer ${token}` } : {};
                          const r = await axios.post(`${CONFIG.API_URL}/api/products/product/${product.id}/like`, {}, { headers });
                          setProduct(prev => ({ ...prev, likes: r.data.likes }));
                          setLiked(!!r.data.liked);
                        } catch (err) { } finally { setLiking(false); }
                      }}
                    >
                      <i className={`${liked ? "fas" : "far"} fa-heart text-xl`}></i>
                      <span>{product.likes} {t('product_detail.likes', 'Likes')}</span>
                    </button>

                    <div className="flex gap-3">
                      {/* WhatsApp Share */}
                      <a
                        href={`https://wa.me/${BRANDING.socialLinks.whatsapp.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(`${isArabic && product.name_ar ? product.name_ar : product.name}\n${window.location.href}`)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                          if (window.fbq) window.fbq('track', 'Contact', { content_name: 'Product WhatsApp Share' });
                          if (window.ttq) window.ttq.track('Contact');
                        }}
                        className="w-14 h-14 rounded-2xl bg-green-500 text-white flex items-center justify-center hover:scale-105 active:scale-95 transition-all shadow-lg shadow-gray-200"
                      >
                        <i className="fab fa-whatsapp text-xl"></i>
                      </a>

                      {/* Facebook Share */}
                      <a
                        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                          if (window.fbq) window.fbq('track', 'Share', { content_name: 'Product Facebook Share' });
                          if (window.ttq) window.ttq.track('Share');
                        }}
                        className="w-14 h-14 rounded-2xl bg-blue-600 text-white flex items-center justify-center hover:scale-105 active:scale-95 transition-all shadow-lg shadow-gray-200"
                      >
                        <i className="fab fa-facebook-f text-xl"></i>
                      </a>
                      <button
                        onClick={() => { navigator.clipboard.writeText(window.location.href); alert(t('product_detail.link_copied', 'Link copied!')); }}
                        className="w-14 h-14 rounded-2xl bg-gray-800 text-white flex items-center justify-center hover:scale-105 active:scale-95 transition-all shadow-lg shadow-gray-200"
                        title="Copy Link"
                      >
                        <i className="fas fa-link text-lg"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="max-w-3xl mx-auto mt-10">
            <h2 className="text-3xl font-semibold text-center mb-8">📖 My Stories</h2>
            {message && <p className="text-center text-gray-600">{message}</p>}

            {
              loading ? (
                <p className="text-center text-gray-500">Loading stories...</p>
              ) :
                stories.length === 0 ? (
                  <p className="text-center text-gray-500">No stories found.</p>
                ) : (
                  <div className="space-y-8">
                    {stories.map((story) => (
                      <div
                        key={story.id}
                        className="bg-white p-6 rounded-2xl shadow-md border border-gray-200"
                      >
                        <h3 className="text-xl font-bold mb-2">{story.title}</h3>
                        <p className="text-gray-700 mb-4">{story.content}</p>

                        {story.videoUrl ? (
                          <div className="mt-4">
                            <video
                              width="100%"
                              height="auto"
                              controls
                              className="rounded-lg shadow-md"
                            >
                              <source
                                src={story.videoUrl.startsWith('http') ? story.videoUrl : `${CONFIG.API_URL}${story.videoUrl}`}
                                type="video/mp4"
                              />
                              Your browser does not support the video tag.
                            </video>
                          </div>
                        ) : (
                          <p className="text-gray-500 italic animate-pulse">
                            🎬 Video is being generated... Please wait.
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                )}
          </div>

          <div className="mt-16 border-t pt-10">
            <h3 className="text-2xl font-bold mb-4">{t('product_detail.customer_reviews')}</h3>
            {[5, 4, 3, 2, 1].map(star => {
              const count = distribution[star] || 0;
              const percent = reviewsTotal > 0 ? (count / reviewsTotal) * 100 : 0;
              return (
                <div key={star} className="flex items-center gap-2 text-sm mb-1">
                  <span className="w-6">{star}★</span>
                  <div className="flex-1 bg-gray-200 h-2 rounded overflow-hidden">
                    <div className="bg-yellow-400 h-2 rounded" style={{ width: `${percent}%` }} />
                  </div>
                  <span className="text-xs text-gray-500 w-6 text-right">{count}</span>
                </div>
              );
            })}

            <div className="mt-6 flex justify-between items-center">
              <select value={sort} onChange={e => setSort(e.target.value)} className="border p-2 rounded">
                <option value="newest">{t('product_detail.newest')}</option>
                <option value="helpful">{t('product_detail.helpful')}</option>
                <option value="rating">{t('product_detail.highest_rating')}</option>
              </select>
            </div>

            <div className="mt-6 space-y-6">
              {reviews.length === 0 && <p className="text-gray-500 italic">{t('product_detail.no_reviews')}</p>}
              {reviews.map(r => {
                const createdAt = new Date(r.created_at).getTime();
                const diffMins = Math.floor((now - createdAt) / (1000 * 60));
                // This code, requires you to be logged in to edit anything
                // const canEdit = r.user_id == getUser()?.id && diffMins < 15;
                // This code without login, the Guests effectively cannot edit their reviews after posting
                const currentUser = getUser();
                const canEdit = currentUser && r.user_id === currentUser.id && diffMins < 15;
                ////////////////////
                const minsLeft = 15 - diffMins;
                return (
                  <div key={r.id} className="border-b pb-6">
                    <div className="flex justify-between items-start mb-2">
                      <div>
                        <span className="font-bold" style={{ color: 'var(--text-header)' }}>
                          {isArabic ? ` ${r.name} ` : r.name}
                        </span>
                        {r.is_verified && <span className="ml-2 text-green-600 text-xs font-semibold uppercase">{isArabic ? ` ${t('product_detail.verified')}` : `${t('product_detail.verified')}`}</span>}
                        <span className="ml-3 text-yellow-500">{isArabic ? ` ${"★".repeat(r.rating)}` : "★".repeat(r.rating)}</span>
                      </div>
                      {canEdit && editing !== r.id && (
                        <button onClick={() => { setEditing(r.id); setEditData({ rating: r.rating, comment: r.comment }); }} className="text-xs text-brand-primary underline">
                          Edit ({minsLeft}m left)
                        </button>
                      )}
                    </div>
                    {editing === r.id ? (
                      <div className="mt-4 space-y-2 p-4" style={{ backgroundColor: 'var(--bg-body)', borderRadius: 'var(--card-radius)' }}>
                        <select value={editData.rating} onChange={e => setEditData({ ...editData, rating: e.target.value })} className="border p-1 rounded">
                          {[5, 4, 3, 2, 1].map(n => <option key={n} value={n}>{n} {t('product_detail.stars')}</option>)}
                        </select>
                        <textarea className="w-full border rounded p-2 text-sm" value={editData.comment} onChange={e => setEditData({ ...editData, comment: e.target.value })} />
                        <div className="flex gap-2">
                          <button onClick={() => saveEdit(r.id)} className="bg-brand-primary text-white px-3 py-1 rounded text-xs">Save</button>
                          <button onClick={() => setEditing(null)} className="text-gray-400 text-xs">Cancel</button>
                        </div>
                      </div>
                    ) : <p className="mt-2" style={{ color: 'var(--text-main)' }}>{r.comment}</p>}
                    <div className="flex items-center gap-4 mt-3 text-xs text-gray-500">
                      <button onClick={() => voteHelpful(r.id)} className="flex items-center gap-1 hover:text-brand-primary transition">
                        👍 {t('product_detail.helpful_btn')} ({r.helpful_count})
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>

            {reviewsTotal > reviewsPer && (
              <div className="flex items-center gap-3 mt-8 justify-center">
                <button onClick={() => setReviewsPage(p => Math.max(1, p - 1))} className="px-3 py-1 bg-gray-100 rounded disabled:opacity-50" disabled={reviewsPage <= 1}>{t('product_detail.prev')}</button>
                <span className="text-sm">{t('product_detail.page')} {reviewsPage} / {Math.ceil(reviewsTotal / reviewsPer)}</span>
                <button onClick={() => setReviewsPage(p => p + 1)} className="px-3 py-1 bg-gray-100 rounded disabled:opacity-50" disabled={reviewsPage >= Math.ceil(reviewsTotal / reviewsPer)}>{t('product_detail.next')}</button>
              </div>
            )}

            <div className="mt-12 p-6 border border-dashed" style={{ backgroundColor: 'var(--bg-body)', borderRadius: 'var(--card-radius)', borderColor: 'var(--border)' }}>
              <h4 className="text-xl font-bold mb-4">{t('product_detail.write_review')}</h4>
              <div className="flex items-center gap-4 mb-4">
                <span className="text-sm font-medium">{t('product_detail.your_rating')}:</span>
                <select value={rating} onChange={e => setRating(e.target.value)} className="border p-1 rounded focus:ring-2 focus:ring-blue-400 outline-none">
                  {[5, 4, 3, 2, 1].map(n => <option key={n} value={n}>{n} {t('product_detail.stars')}</option>)}
                </select>
              </div>
              <div style={{ display: 'none' }}>
                <input type="text" value={honeypot} onChange={e => setHoneypot(e.target.value)} tabIndex="-1" autoComplete="off" />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <input type="text" className="w-full border rounded-lg p-2 text-sm focus:ring-2 focus:ring-blue-400 outline-none" placeholder={t('product_detail.name_req', 'Name (Required)')} value={reviewName} onChange={e => setReviewName(e.target.value)} required aria-required="true" />
                <input type="text" className="w-full border rounded-lg p-2 text-sm focus:ring-2 focus:ring-blue-400 outline-none" placeholder={t('product_detail.contact_opt', 'Phone/Email (Optional, private)')} value={contact} onChange={e => setContact(e.target.value)} />
              </div>
              <textarea className="w-full border rounded-lg p-3 text-sm focus:ring-2 focus:ring-blue-400 outline-none mb-4 h-32" placeholder={t('product_detail.placeholder')} value={comment} onChange={e => setComment(e.target.value)} />
              <button onClick={submitReview} className="bg-brand-primary hover:bg-brand-primary-hover text-white px-6 py-2 rounded-lg font-semibold transition shadow-md">{t('product_detail.post')}</button>
            </div>
          </div>

          {recommendations.length > 0 && (
            <div className="mt-20 border-t pt-10">
              <h2 className="text-2xl font-bold mb-6 text-center">{t('product_detail.also_like')}</h2>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
                {recommendations.map((p) => (
                  <div key={p.id} className="group cursor-pointer" onClick={() => navigate(`/shop/${p.id}`)}>
                    <div className="aspect-square bg-gray-100 rounded-lg overflow-hidden mb-3 relative">
                      <img src={p.imageUrl || "/placeholder-furniture.jpg"} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition duration-300" />
                    </div>
                    <h3 className="font-semibold text-sm truncate">{i18n.language?.startsWith('ar') && p.name_ar ? p.name_ar : p.name}</h3>
                    <div className="flex items-center mt-1">
                      <Stars value={p.avg_rating || 0} />
                      <span className="text-[10px] text-gray-400 ml-1">({p.reviews_count || 0})</span>
                    </div>
                    <p className="text-brand-primary font-bold text-sm mt-1">{formatPrice(p)}</p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
});

export default ProductDetail;
